export default "/assets/images/wcf-v2.png?7a192b0eb4e6c62d4a8fbd4646ac7116";